import React from 'react';
import { Button, Tooltip } from 'antd';
import { Sun, Moon } from 'lucide-react';
import Icon from '../components/Icon';
import { useThemeMode } from './ThemeProvider';

export default function ColorModeToggle(props) {
  const { mode, toggleMode } = useThemeMode();

  const icon = mode === 'dark' ? <Icon as={Sun} /> : <Icon as={Moon} />;
  const tooltip = mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip title={tooltip}>
      <Button
        type="text"
        shape="circle"
        icon={icon}
        onClick={toggleMode}
        {...props}
      />
    </Tooltip>
  );
}
